import React, { ReactEventHandler, useRef, useLayoutEffect } from 'react';
import InputFieldComponent from './InputField';

function RequestPasswordResetFormComponent({
  onChange,
  onSubmit,
  sending,
  error,
}: {
  onChange?: ReactEventHandler;
  onSubmit?: ReactEventHandler;
  sending: boolean;
  error: string;
}) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useLayoutEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <form noValidate onSubmit={onSubmit}>
        <InputFieldComponent
          id="email"
          placeholder="E-mail"
          name="email"
          type="email"
          required={true}
          onChange={onChange}
          errorMessage={error}
          autoComplete="off"
          ref={inputRef}
          onEnter={() => {}}
        />
        <div className="flex flex-col items-center space-y-3">
          <button
            type="submit"
            className="flex w-full justify-center rounded-xl border border-transparent bg-product-button-primary-enabled-light px-4
            py-2 text-base font-semibold text-product-text-reversed-light shadow-sm hover:bg-product-button-primary-hovered-light focus:outline-none dark:bg-product-button-primary-enabled-dark dark:hover:bg-product-button-primary-hovered-dark"
          >
            {sending ? 'Sending...' : 'Send password reset link'}
          </button>
        </div>
      </form>
    </>
  );
}

export default RequestPasswordResetFormComponent;
